'use client'

import React from 'react'
import { motion } from 'framer-motion'
import { Button } from '@sarkiai/ui'
import { ArrowRight, Sparkles } from 'lucide-react'
import Link from 'next/link'
import Image from 'next/image'
import { useTranslations } from '@/components/I18nProvider'

export function BigCTA() {
  const t = useTranslations('enterprise_page.cta')

  return (
    <section className="py-24 relative px-4 lg:px-12">
      <div className="container mx-auto">
        <div className="relative group rounded-4xl border border-black/5 dark:border-white/10 overflow-hidden">
          {/* Background Image - Full Visible */}
          <div className="relative w-full min-h-[280px] sm:aspect-[21/9] lg:aspect-[3/1]">
            <Image
              src="/assets/covers/liquid/pin-3ba-landscape.webp"
              alt="Big CTA Background"
              fill
              className="object-cover transition-transform duration-1000 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/60" />
          </div>

          {/* Content Overlay */}
          <div className="absolute inset-0 flex flex-col items-center justify-center p-6 md:p-12 text-center space-y-5">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-2xl md:text-4xl uppercase tracking-tighter leading-none text-white max-w-3xl"
            >
              {t('subtitle')}
            </motion.h2>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="flex flex-col sm:flex-row items-center gap-3 pt-2"
            >
              <Button asChild variant="outline" size="default" className="rounded-2xl px-6 h-10 uppercase tracking-widest text-xs border border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white hover:border-white/40 transition-all">
                <Link href="/contact">
                  {t('talk')}
                </Link>
              </Button>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  )
}
